export default function Amenities() {
  const amenities = [
    { icon: 'ri-wifi-line', title: 'Free Wi-Fi', description: 'High-speed internet throughout the property' },
    { icon: 'ri-restaurant-line', title: 'Dining', description: 'Delicious local and international cuisine' },
    { icon: 'ri-car-line', title: 'Parking', description: 'Secure parking available for guests' },
    { icon: 'ri-service-line', title: 'Room Service', description: '24/7 room service at your convenience' },
    { icon: 'ri-shield-check-line', title: 'Security', description: 'Round-the-clock security for your safety' },
    { icon: 'ri-customer-service-2-line', title: 'Reception', description: 'Friendly staff ready to assist you' }
  ];

  return (
    <section id="amenities" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Amenities &amp; Services
          </h2>
          <p className="text-gray-600 text-base max-w-2xl mx-auto">
            Everything you need for a comfortable and convenient stay
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {amenities.map((amenity, index) => (
            <div key={index} className="bg-gray-50 rounded-lg p-8 hover:shadow-lg transition-shadow duration-300">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-4">
                <i className={`${amenity.icon} text-emerald-600 text-2xl w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">{amenity.title}</h3>
              <p className="text-gray-600 text-sm">{amenity.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
